import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Row, Col} from 'react-bootstrap';

import {WellIncrementPattern, NormalizationPreviewWellStatus} from '../../../constants/dataEnum';
import './NormalizationContainer.scss';

class NormalizationViewDataPreview extends Component {
  constructor(props) {
    super(props);
    this.skippedCounter = 0;
    this.invalidCounter = 0;
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.normalCounter = 0;
  }

  shouldComponentUpdate(nextProps) {
    const {
      normalizationState: oldNormalizationState,
      patternView: oldPatternView,
      diluentVolumeView: oldDiluentVolumeView,
      diluentLabware: oldDiluentLabware,
    } = this.props;
    const {
      previewData: oldPreviewData,
      wellIncrementPattern: oldWellIncrementPattern,
      selectedLabware: oldSelectedLabware,
    } = oldNormalizationState;

    const {normalizationState, patternView, diluentVolumeView, diluentLabware} = nextProps;
    const {previewData, wellIncrementPattern, selectedLabware} = normalizationState;

    if (oldPreviewData !== previewData) {
      return true;
    }

    if (oldWellIncrementPattern !== wellIncrementPattern) {
      return true;
    }

    if (oldSelectedLabware !== selectedLabware) {
      return true;
    }

    if (oldPatternView !== patternView) {
      return true;
    }

    if (oldDiluentVolumeView !== diluentVolumeView) {
      return true;
    }

    if (oldDiluentLabware !== diluentLabware) {
      return true;
    }

    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  createPlateColHeader = (colCount) => {
    const cols = [];

    for (let index = 1; index <= colCount; index += 1) {
      cols.push(<td key={`col-header-${index}`}>{index}</td>);
    }

    return (
      <table className="plate-col-header">
        <tbody>
          <tr>{cols}</tr>
        </tbody>
      </table>
    );
  };

  // eslint-disable-next-line class-methods-use-this
  createPlateRowHeader = (rowCount) => {
    const rows = [];

    for (let index = 1; index <= rowCount; index += 1) {
      rows.push(
        <tr key={`row-header-${index}`}>
          <td>{String.fromCharCode(64 + index)}</td>
        </tr>,
      );
    }

    return (
      <table className="plate-row-header">
        <tbody>{rows}</tbody>
      </table>
    );
  };

  createPlateContent(colCount, rowCount, isDiluentLabware = false) {
    const {normalizationState, diluentVolumeView, patternView, setAllowedToNext} = this.props;
    const {previewData, wellIncrementPattern, allowedToNext, diluentName} = normalizationState;

    let dataWithBiggestDiluentVolume = {};

    if (diluentVolumeView) {
      dataWithBiggestDiluentVolume = previewData.reduce((data1, data2) =>
        data1.diluentVol >= data2.diluentVol ? data1 : data2,
      );
    }

    let totalDiluent = 0;

    for (let index = 0; index < previewData.length; index += 1) {
      totalDiluent += previewData[index].diluentVol * 10;
    }

    const rows = [];

    for (let row = 0; row < rowCount; row += 1) {
      const cols = [];

      for (let col = 0; col < colCount; col += 1) {
        if (isDiluentLabware) {
          cols.push(
            <td key={`plate-col-${row}${col}`} className="plate-col-0">
              {isDiluentLabware && (
                <p className="total-diluent-vol">
                  {totalDiluent}
                  &nbsp;μL
                </p>
              )}
            </td>,
          );
        } else if (patternView) {
          if (wellIncrementPattern === WellIncrementPattern.ORDER_BY_ROW) {
            cols.push(
              <td key={`plate-col-${row}${col}`} style={{textAlign: 'center'}}>
                {row < 2 ? row * colCount + (col + 1) : ''}
              </td>,
            );
          } else {
            cols.push(
              <td key={`plate-col-${row}${col}`} style={{textAlign: 'center'}}>
                {col < 2 ? col * rowCount + (row + 1) : ''}
              </td>,
            );
          }
        } else if (diluentVolumeView) {
          const oneTenth = dataWithBiggestDiluentVolume.diluentVol / 10;
          const currentData = previewData.find((data) => data.row === row && data.col === col);
          let className = 'unused';

          if (currentData) {
            className = `filled level-${
              dataWithBiggestDiluentVolume.diluentVol === 0
                ? 0
                : Math.floor((currentData.diluentVol + oneTenth - 0.01) / oneTenth)
            }`;
          }

          cols.push(
            <td key={`plate-col-${row}${col}`} className={className}>
              {}
            </td>,
          );
        } else {
          const currentData = previewData.find((data) => data.row === row && data.col === col);
          let className = 'normal';

          if (!currentData) {
            className = 'unused';
          } else if (currentData.status === NormalizationPreviewWellStatus.INVALID) {
            className = 'invalid';
            this.invalidCounter += 1;
          } else if (currentData.status === NormalizationPreviewWellStatus.SKIPPED) {
            className = 'skipped';
            this.skippedCounter += 1;
          } else {
            // eslint-disable-next-line react/no-unused-class-component-methods
            this.normalCounter += 1;
          }

          cols.push(
            <td key={`plate-col-${row}${col}`} className={className}>
              {}
            </td>,
          );
        }
      }

      rows.push(<tr key={`plate-row-${row}`}>{cols}</tr>);
    }

    const invalidData = previewData.filter((data) => data.status === NormalizationPreviewWellStatus.INVALID);

    const normalData = previewData.filter((data) => data.status === NormalizationPreviewWellStatus.NORMAL);

    if (normalData.length === 0) {
      if (allowedToNext && setAllowedToNext) setAllowedToNext(false);
    } else if (!patternView) {
      if (invalidData.length > 0) {
        if (allowedToNext && setAllowedToNext) setAllowedToNext(false);
      } else if (diluentName !== '') {
        if (!allowedToNext && setAllowedToNext) setAllowedToNext(true);
      }
    }

    return (
      <table className="plate-content">
        <tbody>{rows}</tbody>
      </table>
    );
  }

  createDataPreview() {
    const {diluentVolumeView, normalizationState, patternView} = this.props;
    const {selectedLabware} = normalizationState;
    const plateColHeader = this.createPlateColHeader(selectedLabware.colCount);
    const plateRowHeader = this.createPlateRowHeader(selectedLabware.rowCount);
    const plateContent = this.createPlateContent(selectedLabware.colCount, selectedLabware.rowCount);

    return (
      <div className="data-preview-container">
        <div className="title-section">Preview</div>
        <table className="table-plate-section">
          <tbody>
            <tr>
              <td className="spacer" />
              <td>{plateColHeader}</td>
              <td className="spacer" />
            </tr>
            <tr>
              <td>{plateRowHeader}</td>
              <td>{plateContent}</td>
              <td />
            </tr>
            <tr>
              <td colSpan="3" className="spacer" />
            </tr>
          </tbody>
        </table>
        {diluentVolumeView ? (
          <div>
            <div className="diluent-volume-view-info">
              The color gradient represents the diluent volume to be dispensed in each well. Pure white means nothing
              will be dispensed. The darkest green indicates the well that will have the most diluent dispensed to it.
            </div>
          </div>
        ) : (
          <div className="labware-name">{selectedLabware.name}</div>
        )}
        {!patternView && !diluentVolumeView ? (
          <div className="block-section">
            <Row>
              <Col sm={2} md={1}>
                <div
                  style={{
                    height: '24px',
                    width: '24px',
                    border: 'solid 1px black',
                    backgroundColor: '#ff0000',
                  }}
                />
              </Col>
              <Col sm={5} md={5} style={{color: '#ff0000', padding: '4px 0px 0px 0px'}}>
                Invalid : &nbsp;
                {this.invalidCounter}
              </Col>
              <Col
                sm={5}
                md={5}
                style={{
                  color: '#ff0000',
                  padding: '4px 0px 0px 0px',
                  fontStyle: 'italic',
                  fontSize: '11px',
                }}
              >
                Note:
                <br />
                Invalid means either that the diluent volume exceeds the well capacity or that the reagent volume is
                lower than the target concentration.
              </Col>
            </Row>
            <Row style={{marginTop: '8px'}}>
              <Col sm={2} md={1}>
                <div
                  style={{
                    height: '24px',
                    width: '24px',
                    border: 'solid 1px black',
                    backgroundColor: '#ffe498',
                  }}
                />
              </Col>
              <Col sm={5} md={5} style={{color: '#FFBC00', padding: '4px 0px 0px 0px'}}>
                Skipped : &nbsp;
                {this.skippedCounter}
              </Col>
              <Col
                sm={6}
                md={6}
                style={{
                  color: '#FFBC00',
                  padding: '4px 0px 0px 0px',
                  fontStyle: 'italic',
                  fontSize: '11px',
                }}
              >
                Skipped means either that the concentration has achieved the target concentration or that the reagent
                concentration is lower than the target concentration.
              </Col>
            </Row>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }

  createDiluentPreview() {
    const {diluentLabware, setAllowedToNext, normalizationState} = this.props;
    const {allowedToNext} = normalizationState;

    if (!diluentLabware) {
      if (allowedToNext && setAllowedToNext) {
        setAllowedToNext(false);
      }

      return (
        <div className="data-preview-container">
          <div className="title-section blur">Preview</div>
          <div className="trough-table-plate-section no-border">
            <img
              className="placeholder-img"
              alt="Diluent Preview"
              src="./svg/normalization/normalization-diluent-placeholder.svg"
            />
          </div>
        </div>
      );
    }

    const plateColHeader = this.createPlateColHeader(diluentLabware.rowCount);
    const plateRowHeader = this.createPlateRowHeader(diluentLabware.colCount);
    const plateContent = this.createPlateContent(diluentLabware.rowCount, diluentLabware.colCount, true);

    return (
      <div className="data-preview-container">
        <div className="title-section">Preview</div>
        <table className="trough-table-plate-section">
          <tbody>
            <tr>
              <td style={{height: '24px', width: '24px'}} />
              <td className="column-header-content">{plateColHeader}</td>
              <td style={{width: '24px'}} />
            </tr>
            <tr>
              <td className="row-header-content">{plateRowHeader}</td>
              <td className="content">{plateContent}</td>
              <td />
            </tr>
            <tr>
              <td colSpan="3" style={{height: '24px'}} />
            </tr>
          </tbody>
        </table>
        <div className="labware-name">{diluentLabware.name}</div>
      </div>
    );
  }

  render() {
    const {diluentSelectionView, normalizationState} = this.props;
    const {colCount, rowCount} = normalizationState.selectedLabware;
    const wellCount = colCount * rowCount;

    this.skippedCounter = 0;
    this.invalidCounter = 0;

    const dataPreview = diluentSelectionView ? this.createDiluentPreview() : this.createDataPreview();

    return (
      <div className={`data-preview-container ${diluentSelectionView ? 'grid' : ''}  plate-${wellCount}`}>
        {dataPreview}
      </div>
    );
  }
}

export default NormalizationViewDataPreview;

NormalizationViewDataPreview.propTypes = {
  normalizationState: PropTypes.any.isRequired,
  patternView: PropTypes.bool,
  diluentVolumeView: PropTypes.bool,
  diluentSelectionView: PropTypes.bool,
  setAllowedToNext: PropTypes.func,
  diluentLabware: PropTypes.any,
};

NormalizationViewDataPreview.defaultProps = {
  patternView: false,
  diluentVolumeView: false,
  diluentSelectionView: false,
  setAllowedToNext: () => {},
  diluentLabware: null,
};
